import axiosNew from '../../helpers/axios'

const TALENT_USER_SELECT = [
    'name',
    'email',
    'employeeNumber',
    'phone',
    'countryCode',
    'flag',
    'address',
    'employmentType',
    'state',
    'department',
    'designation',
    'emergencyName',
    'emergencyPhone',
    'notes',
    'role',
    'isActive',
    'profilePicture',
    'isOurUser',
    'isAssigned',
    'isWorkspaceAssigned',
    'isTalentUser',
    'price',
    'dailyWorkingHours',
    'weeklyWorkingDays',
    'status',
    'timeZone',
]

const TALENT_USER_POPULATE = {
    name: [
        {
            path: 'role',
            select: 'roleName',
        },
        {
            path: 'workspace',
            select: 'domain logo companyName',
        },
    ],
}

export const getSupportUsers = async ({
    skip = 0,
    limit = 20,
    search = '',
    filter = {},
} = {}) => {
    try {
        const data = {
            skip,
            filter: {
                status: 'accepted',
                isTalentUser: true,
                isOurUser: true,
                ...filter,
            },
            limit,
            select: TALENT_USER_SELECT,
            populate: TALENT_USER_POPULATE,
        }

        if (search?.length > 0) {
            data.search = {
                name: search,
                email: search,
                phone: search,
            }
        }

        const response = await axiosNew({
            url: 'support/read',
            method: 'POST',
            data,
        })

        const payload = response?.data ?? {}

        return {
            users: payload?.result ?? payload?.data ?? [],
            isNext: Boolean(payload?.isNext),
            count: payload?.count ?? payload?.total ?? payload?.totalCount ?? null,
        }
    } catch (error) {
        return {
            users: [],
            isNext: false,
            count: null,
        }
    }
}

export const listTalentPermissions = async (talentSupportUserId) => {
    try {
        const response = await axiosNew({
            url: 'talent/permissions/list',
            method: 'POST',
            data: {
                talentSupportUserId: String(talentSupportUserId),
            },
        })
        return { data: response?.data ?? {} }
    } catch (error) {
        return { data: error?.response?.data ?? {} }
    }
}

export const setTalentPermissions = async ({
    talentSupportUserId,
    permissions,
}) => {
    try {
        const response = await axiosNew({
            url: 'talent/permissions/set',
            method: 'POST',
            data: {
                talentSupportUserId: String(talentSupportUserId),
                permissions,
            },
        })
        return { data: response?.data ?? {} }
    } catch (error) {
        return { data: error?.response?.data ?? {} }
    }
}
